module.exports = __webpack_public_path__ + "img/lia_logo.35476eb0.webp";